import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isActive: false,
    message: "",
    type: "",
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        addNotification: (state, action) => {
            state.isActive = true;
            state.message = action.payload.message;
            state.type = action.payload.type;
        },
        removeNotification: (state) => {
            state.isActive = false;
            state.message = "";
            state.type = "";
        },
    },
});

const notificationReducer = notificationSlice.reducer
export const {addNotification, removeNotification } = notificationSlice.actions;
export default notificationReducer